export default __webpack_public_path__ + "static/media/reroll.700d9fbb.png";